let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2kKFX")).then(() => parcelRequire('3jte6'));